import React, { Component } from 'react';
import {Clearfix, Button, Row, Col, ControlLabel, FormGroup} from 'react-bootstrap';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";
import SelectWrap from "../../../../components/SelectWrap";
import countriesObj from "../../../../data/countries";


class CountriesForm extends Component {
    constructor(props) {
        super(props);

        this.state = { countries: null };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.countries);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <div style={{ width: '80%'}}>
                    <SelectWrap

                        values={countriesObj}
                        label="Countries:"
                        name="countries"
                        onChange={this.handleFieldChange}
                        value={this.state.countries || this.props.countries}
                        multi
                        required
                    />
                    </div>

                    <Button style={{ height: 'auto', marginLeft: 'auto'}} bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </div>
            </form>
        );
    }
}

export default CountriesForm;


// WEBPACK FOOTER //
// ./src/scenes/Dating/components/CountriesForm/index.js